import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import TimeSlots from '../../../../Shared/TimeSlots/TimeSlots';
import { setTechnicianDay, setTechnicianSelectedTime, reportDWH } from '../../AddonsBlockSlice';
import { createSaleAsync } from '../../AddonsBlockAsyncThunk';
import { gtag4 } from '../../../../../utilities/analytics/tracking';

const TechnicianPage = (props) => {

    useEffect(() => {
        props.reportDWH({ actionType: 'Technician Date', status: 'Ongoing', messageText: 'Technician Date Page Displayed' });
        gtag4({ event: `Addon_${props.flowType}_Step4_TechnicianPage`, step: '4', action: 'TechnicianPage', funnel_name: `Addon_${props.flowType}` });
    }, []);

    return (
        <div className='technician-page'>

            <div className='page-title'> נוכל להגיע אליך כבר ב{props.firstTechnicianTimeDisplay} </div>
            <div className='page-sub-title'> לשינוי, יש לבחור את היום והשעה הנוחים לך <br /> כתובת להתקנה: {props.fullAddress} </div>

            <div className='technician-time-slots'>
                <TimeSlots technicianTimes={props.technicianTimes} onSelectDay={handleSelectDay} onSelectHours={handleSelectHours} />
            </div>

            <div className='button-wrapper'>
                <BtnSubmit
                    isBusiness={false}
                    text='אישור והזמנה'
                    onclick={handleOnContinue}
                    formid='service-page'
                    isDisplayArrows={false}
                    isDisplayWhatsAppIcon={false}
                />
            </div>

        </div>
    );

    function handleSelectDay(data) {
        props.setTechnicianDay(data);
        console.info('handleSelectDay', data);
    }

    function handleSelectHours(data) {
        props.setTechnicianSelectedTime(data);
        console.info('handleSelectHours', data);
    }

    function handleOnContinue() {
        props.reportDWH({ actionType: 'Technician Date', status: 'Ongoing', messageText: 'Technician Date Page Button Clicked' });
        gtag4({ event: `Addon_${props.flowType}_Step4_TechnicianContinueButton`, step: '4', action: 'TechnicianContinueButton', funnel_name: `Addon_${props.flowType}` });
        props.createSaleAsync();
    }

};

const mapStateToProps = (state) => {
    return {
        flowType: state.addonsBlock.flowType,
        technicianTimes: state.addonsBlock.technician.technicianTimes,
        firstTechnicianTimeDisplay: state.addonsBlock.technician.firstTechnicianTimeDisplay,
        fullAddress: state.addonsBlock.subscriber.address.fullAddress,
    };
};

const mapDispatchToProps = {
    setTechnicianDay,
    setTechnicianSelectedTime,
    createSaleAsync,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianPage);
